export function DragStartHandler(e, card, index, cardState, callBack) {
    callBack({
        ...cardState,
        index: index,
        title: card.detail,
        targetCard: e.target,
    });
}

export function DragOverHandler(e) {
    e.stopPropagation();
    e.preventDefault();
}

export function DropHandler(left, top, targetIndex, cardState, callBack) {
    callBack((current) =>
        current.map((card, i) => {
            if (i === cardState.index && cardState.index === targetIndex) {
                return {
                    ...card,
                    current: {
                        left: left ? left : '',
                        top: top ? top : '',
                    },
                    target: left ? targetIndex + 1 : 0,
                    isDropped: left ? true : false,
                };
            }
            return card;
        }),
    );
}
